import React from 'react';
import { keyCodes } from '@wix/editor-elements-common-utils';
import type { INavButtonProps } from '../../Pagination.types';
import { st, classes } from './style/NavButton.st.css';

const NavButton: React.ForwardRefRenderFunction<
  HTMLAnchorElement | HTMLButtonElement,
  INavButtonProps
> = (
  {
    testId,
    className,
    children,
    onChange,
    isDisabled: disabled,
    ariaLabel,
    url,
    showClassicPaginationAsList = false,
  },
  ref,
) => {
  const onKeyDownHandler = (event: React.KeyboardEvent) => {
    const { keyCode } = event;
    if (keyCode === keyCodes.enter || keyCode === keyCodes.space) {
      event.preventDefault(); // prevents viewer from scrolling after keyboard press
      !disabled && onChange();
    }
  };

  const onClickHandler = (event: React.MouseEvent) => {
    event.preventDefault();
    !disabled && onChange();
  };

  const commonProps = {
    'data-testid': testId,
    className: st(classes.root, { disabled }, className),
    'aria-label': ariaLabel,
    'aria-disabled': disabled,
    onClick: onClickHandler,
    onKeyDown: onKeyDownHandler,
  };

  if (showClassicPaginationAsList) {
    return (
      <button
        ref={ref as React.Ref<HTMLButtonElement>}
        {...commonProps}
        disabled={disabled}
        {...(!disabled && {
          tabIndex: 0,
        })}
      >
        {children}
      </button>
    );
  }

  return (
    <a
      ref={ref as React.Ref<HTMLAnchorElement>}
      {...commonProps}
      {...(!disabled && {
        tabIndex: 0,
      })}
      href={url}
    >
      {children}
    </a>
  );
};

export default React.forwardRef(NavButton);
